"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _postal = _interopRequireDefault(require("@mtt/postal"));

var _state = require("./state");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  if (_state.state._config.sendPreservedToRemote) {
    _postal.default.iterateOverQueue(function (envelope) {
      if (_postal.default.fedx.canSendRemote(envelope.channel, envelope.topic)) {
        _postal.default.fedx.sendMessage(envelope);
      }
    });
  }
};

exports.default = _default;